import RecipientSlug from './recipient-slug'

export default RecipientSlug
